<template>
  <div class="news-list">
    <template v-for="(news, index) in newsList">
      <div
        :key="index"
        class="news-card"
        @click="goToNewsDetailPage(news.id)">
        <div class="news-image">
          <img :src="news.images[0]" class="image_course_thumbnail">
        </div>
        <div class="news-card-content">
          <article>
            <h4 class="title">{{ news.title }}</h4>
            <p class="org-name">{{ news.organize.name }}</p>
            <p class="timestamp">
              <fa-icon icon="clock"></fa-icon>
              {{ news.published_at }}
            </p>
          </article>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'news-list',
    props: {
      newsList: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    watch: {
      newsList: val => {
        this.newsList = val
      }
    },
    methods: {
      goToNewsDetailPage (newsId) {
        this.$router.push(`/news/${newsId}`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  .image_course_thumbnail{
    max-height: 50vw;
    display:block;
    margin-left: auto;
    margin-right: auto;
    object-fit: contain;
    width: 100%;
  }

  .news-list {
    .news-card {
      @extend .shadow;
      @extend .cursor-pointer;
      margin: 10px 10px 20px;
      border-radius: 10px;
      background-color: white;
      .title {
        font-size: 18px;
      }
      .news-image {
        @extend .bg-cover;
        height: 50vw;
        border-radius: 10px 10px 0 0;
      }
      .news-card-content {
        padding: 15px;
        .org-name {
          margin-bottom: 0;
          font-weight: 400;
        }
        .timestamp {
          margin-bottom: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsList.component.vue